import { render } from "./OverlayWindow.vue?vue&type=template&id=22e05055&scoped=true"
import script from "./OverlayWindow.vue?vue&type=script&lang=js"
export * from "./OverlayWindow.vue?vue&type=script&lang=js"

import "./OverlayWindow.vue?vue&type=style&index=0&id=22e05055&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22e05055"]])

export default __exports__